import { Component } from '@angular/core';

@Component({ standalone: false, 
  templateUrl: './research.component.html',
})
export class ResearchComponent {}
